export const SNACKBAR_GENERAL_ERROR_BOLD_MSG = (
  <>
    An error occurred and some changes didn't get saved correctly. Please try
    again. If the error persists, please enter a <b>SNOW </b>ticket.
  </>
);

export const SNACKBAR_SEARCH_PERSON_TO_NAVIGATE_ERROR_MSG = (
  <>
    An error occurred. Please try again. If the error persists, please enter a{' '}
    <b>SNOW</b> ticket.
  </>
);
